import { Empty } from 'antd';
import { FC, memo } from 'react';

import { ErrorAlert } from '@/common/components';
import { QueryError } from '@/common/interfaces';

interface Props {
  isError: boolean;
  error: QueryError | null;
  description: string;
}

export const FormSelectNotFoundContent: FC<Props> = memo(({ isError, error, description }) => {
  if (isError) return <ErrorAlert size="small" withReload={ false } error={ error }/>;

  return <Empty image={ Empty.PRESENTED_IMAGE_SIMPLE } description={ description } style={{ padding: 0 }}/>;
});
